// extracted by css-extract-rspack-plugin
export default {"cls1":"LoggedInDiscoveryPage-cls1_64A","cls2":"LoggedInDiscoveryPage-cls2_rqn LoggedInDiscoveryPage-cls1_64A"};